'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _utils = require('../utils');

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageNav = function () {
  function PageNav(el) {
    (0, _classCallCheck3.default)(this, PageNav);

    this.isTicking = false;
    this.lastKnownY = window.scrollY;
    this.isOnMobile = window.innerWidth <= _utils.mediaBreakpoints.sm;

    this.el = el;
    this.els = {
      pageNav: (0, _functional.getElement)('.nav-PageNav'),
      header: (0, _functional.getElement)('.nav-Banner_Items'),
      surround: this.el.querySelector('.nav-PageNav_Surround'),
      triggers: this.el.querySelectorAll('[data-trigger]'),
      sections: document.querySelectorAll('[data-section]')
      // select: this.el.querySelector('.prj-Navigation_Select')
    };
    this.fragmentPairs = this.setupFragmentPairs();

    this.navTriggerPoint = this.getNavTriggerPoint();
    this.activeFragment = this.getActiveFragment();

    this.setupListeners();
    this.onScroll();
  }

  (0, _createClass3.default)(PageNav, [{
    key: 'setupListeners',
    value: function setupListeners() {
      var _this = this;

      // Where most of the glory happens
      window.addEventListener('scroll', this.onScroll.bind(this));

      // This will handle scrolling to a specific section
      this.els.surround.addEventListener('click', function (e) {
        e.preventDefault();

        var target = e.target;


        if (Array.from(_this.els.triggers).includes(target)) {
          (0, _utils.scrollToY)(Object.values(_this.fragmentPairs).find(function (obj) {
            return obj.els.anchor === target;
          }).triggerPoint);
        }
      });

      // We'll need to redo all of our trigger points on a window resize
      window.addEventListener('resize', (0, _utils.debounce)(this.handleWindowResize.bind(this), 200));

      // Handle the "mobile" select
      // this.els.select.addEventListener('change', e => {
      //   scrollToY(
      //     Object.values(this.fragmentPairs).find(obj => obj.name === e.target.value).triggerPoint
      //   )
      // })
    }
  }, {
    key: 'handleWindowResize',
    value: function handleWindowResize() {
      this.isOnMobile = window.innerWidth <= _utils.mediaBreakpoints.sm;

      this.lastKnownY = window.scrollY;
      this.fragmentPairs = this.setupFragmentPairs();

      this.navTriggerPoint = this.getNavTriggerPoint();
      this.activeFragment = this.getActiveFragment();
    }
  }, {
    key: 'onScroll',
    value: function onScroll() {
      this.lastKnownY = window.scrollY;

      this.requestTick();
    }
  }, {
    key: 'requestTick',
    value: function requestTick() {
      if (!this.isTicking) window.requestAnimationFrame(this.updateEl.bind(this));

      // If a rAF is already queued we don't want to call another one
      this.isTicking = true;
    }
  }, {
    key: 'updateEl',
    value: function updateEl() {
      // Reset the tick so we can capture the next onScroll
      this.isTicking = false;

      // Set whether the navigation is fixed or not
      this.els.surround.classList.toggle('nav-PageNav_Surround-fixed', this.lastKnownY >= this.navTriggerPoint);

      // Do we need to update the current active link?
      var activeFragment = this.getActiveFragment();
      if (activeFragment !== this.activeFragment) {
        this.activeFragment = activeFragment;
      }
    }
  }, {
    key: 'getNavTriggerPoint',
    value: function getNavTriggerPoint() {
      return (0, _utils.getOffsetTop)(this.els.pageNav) - this.els.header.offsetHeight;

      // return this.isOnMobile ? offset - this.els.header.offsetHeight : offset
    }
  }, {
    key: 'setupFragmentPairs',
    value: function setupFragmentPairs() {
      var _this2 = this;

      return Array.from(this.els.triggers).reduce(function (obj, el) {
        var sectionEl = Array.from(_this2.els.sections).find(function (secEl) {
          return secEl.dataset.section === el.dataset.trigger;
        });
        var style = window.getComputedStyle(sectionEl);

        obj[el.dataset.trigger] = {
          name: el.dataset.trigger,
          els: {
            anchor: el,
            section: sectionEl
          },
          triggerPoint: (0, _utils.getOffsetTop)(sectionEl) - parseInt(style.marginTop, 10) - _this2.el.offsetHeight - _this2.els.header.offsetHeight
        };

        return obj;
      }, {});
    }
  }, {
    key: 'getActiveFragment',
    value: function getActiveFragment() {
      var _this3 = this;

      var obj = Object.values(this.fragmentPairs).reverse().find(function (obj) {
        return obj.triggerPoint <= _this3.lastKnownY;
      });

      return obj ? obj.name : Array.from(this.els.triggers)[0].dataset.trigger;
    }
  }, {
    key: 'activeFragment',
    get: function get() {
      return this._activeFragment;
    },
    set: function set(val) {
      this._activeFragment = val;

      Array.from(this.els.triggers).map(function (el) {
        el.setAttribute('aria-current', el.dataset.trigger === val);
      });

      // this.els.select.value = val
    }
  }]);
  return PageNav;
}();

exports.default = PageNav;